import { Box, Flex, Pane, TextArea } from '@fullstory/components';
import React, { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { CopyTextBtn } from '../CopyTextBtn';
import css from './index.module.scss';

interface UserOverlayExpandableListItemProps {
  serverEventVars?: string;
  isExpanded: boolean;
}

export const UserOverlayExpandableListItem: FC<
  PropsWithChildren<UserOverlayExpandableListItemProps>
> = ({ serverEventVars, isExpanded, children }) => (
  <Pane
    data-component="UserOverlayExpandableListItem"
    className={isExpanded ? css.expandedEventInfoListItem : css.listItem}
    backgroundColor="default"
    borderRadius={8}
    testId="event-shell"
    elevation={isExpanded ? 2 : 0}
    padding={[12, 0]}
  >
    {children}
    {isExpanded ? (
      <Pane padding={[0, 16, 0, 16]}>
        <>
          <Box marginBottom={8}>
            <TextArea readOnly value={serverEventVars} rows={5} size="x-small" />
          </Box>
          <Flex justifyContent="flex-end">
            <CopyTextBtn text={serverEventVars || ''} appearance="bodySmall" color="brand">
              <FormattedMessage defaultMessage="Copy to clipboard" id="aCdAsI" />
            </CopyTextBtn>
          </Flex>
        </>
      </Pane>
    ) : null}
  </Pane>
);
